import { observe } from "selector-observer";
const installedForms = new WeakMap();
function validate(form) {
    const validity = form.checkValidity();
    for (const button of form.querySelectorAll("button[data-disable-invalid]")) {
        button.disabled = !validity;
    }
}
function installHandlers(form) {
    if (installedForms.get(form)) {
        return;
    }
    form.addEventListener("change", () => validate(form));
    installedForms.set(form, true);
}
observe("button[data-disable-invalid]", {
    constructor: HTMLButtonElement,
    initialize(observedEl) {
        const { form } = observedEl;
        if (form) {
            installHandlers(form);
            observedEl.disabled = !form.checkValidity();
        }
    },
});
